var ZcamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ObjectUtils } from "../../utils/object-utils";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { ActivatedRoute, Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { ApiZoningCertificateConstants } from "../../constants/api-constants/api-zoning-certificate.constants";
import { ViewApplicationDetailsZcamsComponent } from "../../../application/view-application/modules/zc/view-application-details-zcams/view-application-details-zcams.component";
import { ViewApplicationLocationZcamsComponent } from "../../../application/view-application/modules/zc/view-application-location-zcams/view-application-location-zcams.component";
import { CreateApplicationDetailsZcamsComponent } from "../../../application/create-application/modules/zc/create-application-details-zcams/create-application-details-zcams.component";
import { CreateApplicationLocationZcamsComponent } from "../../../application/create-application/modules/zc/create-application-location-zcams/create-application-location-zcams.component";
import { SearchApplicationTypeZcamsComponent } from "../../../tabs/applications/application-search/modules/zc/search-application-type-zcams/search-application-type-zcams.component";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var ZcamsSearchOptions;
(function (ZcamsSearchOptions) {
    ZcamsSearchOptions["ReferenceNumber"] = "Reference Number";
    ZcamsSearchOptions["MyApplications"] = "My Applications";
    ZcamsSearchOptions["ApplicantAgent"] = "Applicant Agent";
    ZcamsSearchOptions["ApplicantInfo"] = "Applicant Information";
    ZcamsSearchOptions["AppID"] = "Application ID";
    ZcamsSearchOptions["ApplicationStatus"] = "Application Status";
    ZcamsSearchOptions["ApplicationCategory"] = "Application Category";
    ZcamsSearchOptions["ApplicationTypes"] = "Application Types";
    ZcamsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    ZcamsSearchOptions["AssignedToUsers"] = "Assigned to";
    ZcamsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    ZcamsSearchOptions["CreatedDate"] = "Created Date";
    ZcamsSearchOptions["CreatedDateRange"] = "Created Date Range";
    ZcamsSearchOptions["StartDate"] = "Started Date";
    ZcamsSearchOptions["StartDateRange"] = "Started Date Range";
    ZcamsSearchOptions["DaysUntilExpired"] = "Days until Expired";
    ZcamsSearchOptions["OwnerInfo"] = "Owner Information";
    ZcamsSearchOptions["PercentageComplete"] = "Percentage Complete";
    ZcamsSearchOptions["TimeoutStatus"] = "Timeout Status";
    ZcamsSearchOptions["JobID"] = "Job ID";
})(ZcamsSearchOptions || (ZcamsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    [ApplicationHeadingEnum.ApplicationType, "type"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["FarmNumber"] = "Farm Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.FarmNumber, "farmNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "type"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const ZcamsSearchQueryLookup = new Map([
    [ZcamsSearchOptions.AppID, "appId"],
    [ZcamsSearchOptions.ReferenceNumber, "referenceNumber"],
    [ZcamsSearchOptions.JobID, "jobId"]
]);
export const ZcamsAdditionalSearchOptions = [ZcamsSearchOptions.MyApplications,
    ZcamsSearchOptions.AssignedToUsers,
    ZcamsSearchOptions.UnassignedApplications,
    ZcamsSearchOptions.ApplicationsWithoutStartDate];
export const ZcamsDateSearchOptions = new Map([
    [ZcamsSearchOptions.CreatedDate, 1],
    [ZcamsSearchOptions.CreatedDateRange, 2],
]);
export const ZcamsStartRangeDateSearchOptions = new Map([
    [ZcamsSearchOptions.StartDate, 1],
    [ZcamsSearchOptions.StartDateRange, 2],
]);
export const ZcamsStatusSearchOptions = new Map([
    [ZcamsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [ZcamsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [ZcamsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [ZcamsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const ZcamsSearchOptionClientHeight = new Map([
    [ZcamsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [ZcamsSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [ZcamsSearchOptions.AppID, SearchContainerHeight.Simple],
    [ZcamsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.ApplicationTypes, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [ZcamsSearchOptions.ApplicantAgent, SearchContainerHeight.Extended],
    [ZcamsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended],
    [ZcamsSearchOptions.OwnerInfo, SearchContainerHeight.Extended],
]);
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var ZcamsSearchOptionTableListEnum;
(function (ZcamsSearchOptionTableListEnum) {
    ZcamsSearchOptionTableListEnum["Application"] = "A_APPLICATION|Application";
    ZcamsSearchOptionTableListEnum["Property"] = "A_APPLICATIONPROPERTY|Properties";
    ZcamsSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
    ZcamsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    ZcamsSearchOptionTableListEnum["ApplicationType"] = "A_APPLICATION|Type";
    ZcamsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    ZcamsSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
})(ZcamsSearchOptionTableListEnum || (ZcamsSearchOptionTableListEnum = {}));
export const AExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_ZC;
export const ATableNameListForSearchOptions = ZcamsSearchOptionTableListEnum.Application
    + "," + ZcamsSearchOptionTableListEnum.Property
    + "," + ZcamsSearchOptionTableListEnum.Owner
    + "," + ZcamsSearchOptionTableListEnum.Status
    + "," + ZcamsSearchOptionTableListEnum.ApplicationType
    + "," + ZcamsSearchOptionTableListEnum.Applicant
    + "," + ZcamsSearchOptionTableListEnum.ApplicantAgent;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const ZcRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let ZcamsStrategyService = class ZcamsStrategyService extends AflaModuleStrategyService {
    static { ZcamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    route;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.ZoningCertificate;
    modulePrefix = ModulePrefix.ZoningCertificate;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
    applicationServiceUrl = ApiZoningCertificateConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = AExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = AExpandListForApplicationSearch;
    searchOptionTableNameList = ATableNameListForSearchOptions;
    customApplicationTableColumnMap = null;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Application help",
        "Property help",
        "Applicant help",
        "Agent help",
        "Communication help",
        "Required documentation help",
        "Notes help",
        "Summary help",
        "Create application status page",
        "View application status page"
    ];
    setApplicantAndApplicantAgentAction = ApiZoningCertificateConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    createApplicationZcamsSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService, route) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.route = route;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.ZONING_CERTIFICATE_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = ZcRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, AExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = ZcamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    getApplicationTypesForModule(moduleID) {
        return this.applicationSearchService.getApplicationTypesForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = ZcamsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = ZcamsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(ZcamsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(ZcamsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = ZcamsDateSearchOptions;
        this.RangeSearchOptions = ZcamsStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = ZcamsStatusSearchOptions;
        this.clientHeightMap = ZcamsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: ZcamsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: ZcamsStrategyService_1.getRecipientName(ZcamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: ZcamsStrategyService_1.getRecipientName(ZcamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            farmNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "farmNumber"),
            type: application.type,
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "properties":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // Owner is the only 3rd level table that is referenced
        const propertyDetails = [ApplicationSearchConstants.ZONINGS, ApplicationSearchConstants.OWNERS];
        if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
            if (application.properties.length > 0) {
                application.properties.forEach((property) => {
                    for (const [propkey, propVal] of Object.entries(property)) {
                        if (propkey.toLowerCase() === appGroup.toLowerCase()
                            || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS))) {
                            propVal.forEach((value) => {
                                for (const [groupKey, groupValue] of Object.entries(value)) {
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(ZcamsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsZcamsComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationZcamsComponent,
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsZcamsComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationZcamsComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [ZcamsSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [ZcamsSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [ZcamsSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [ZcamsSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [ZcamsSearchOptions.StartDate, SearchStartDateComponent],
            [ZcamsSearchOptions.StartDateRange, SearchStartDateComponent],
            [ZcamsSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [ZcamsSearchOptions.PercentageComplete, SearchStatusComponent],
            [ZcamsSearchOptions.ApplicationStatus, SearchStatusComponent],
            [ZcamsSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [ZcamsSearchOptions.TimeoutStatus, SearchStatusComponent],
            [ZcamsSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [ZcamsSearchOptions.ApplicationTypes, SearchApplicationTypeZcamsComponent],
            [ZcamsSearchOptions.OwnerInfo, SearchOwnerInfoComponent]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = ZcamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), ZcamsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = ZcamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, ZcamsStrategyService_1.buildModuleIDFilter(moduleID), ZcamsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = ZcamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateZcamsApplication");
        const application = this.buildApplication();
        this.createApplicationZcamsSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(ZcamsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateZcamsApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateZcamsApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "point, polygon",
            $expand: "point, polygon",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiZoningCertificateConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, properties($expand=owners), lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_ZC_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_ZC_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_ZC_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiZoningCertificateConstants.URL}/${applicationId}/${ApiZoningCertificateConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiZoningCertificateConstants.URL}/${applicationId}/${ApiZoningCertificateConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        var params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiZoningCertificateConstants.URL}/${moduleId}/${ApiZoningCertificateConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initForm() {
        // this.tableHeadingsIsChangedObservable = this.tableHeadingsIsChanged.asObservable()
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                type: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null),
            }),
            propertiesForm: new FormGroup({
                properties: new FormArray([], [minLengthArray(1), Validators.required]),
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        const application = {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            type: this.form.get("detailsForm").get("type").value?.value,
            shape: "",
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            properties: [],
            eLodgementStep: 0,
            eLodgementComplete: true,
            applicantAgentNa: !markApplicantAgentAsNotApplicable
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const owners = item.get("owners").value.recipients;
            owners.forEach((owner) => {
                owner = RecipientUtils.removeRecipientProperties(owner);
            });
            const property = {
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                farmNumber: item.get("farmNo").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                updateGeometry: false,
                wkid: 102100,
                owners,
            };
            application.properties.push(property);
        });
        const shape = `MULTIPOINT (${points.join(", ")})`;
        application.shape = shape;
        return application;
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiZoningCertificateConstants.URL}/${jobId}/${ApiZoningCertificateConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService },
        { type: ActivatedRoute }
    ];
};
ZcamsStrategyService = ZcamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], ZcamsStrategyService);
export { ZcamsStrategyService };
